export enum ReceiptTextAlign {
  left,
  center,
  right,
}